import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import form from "./form";
import ui from "./ui";

import "@/common/init";

createApp(App).use(store).use(router).use(form).use(ui).mount("#app");
